export var createDerivedColors = function (mode) {
    var isLightMode = mode === "light";
    var brand100 = "#E0F8FF";
    var brand200 = "#BEEFFE";
    var brand300 = "#86DEF9";
    var brand400 = "#22B9E6";
    var brand500 = "#009AC8";
    var brand600 = "#0C80B6";
    var brand700 = "#0771A6";
    var brand800 = "#00497A";
    var brand900 = "#123349";
    var success100 = "#E8FCE8";
    var success200 = "#B0EEB0";
    var success300 = "#6CCC6D";
    var success400 = "#34AD48";
    var success500 = "#0A8930";
    var success600 = "#097228";
    var success700 = "#056121";
    var success800 = "#034516";
    var success900 = "#013202";
    var error100 = "#FCE8E9";
    var error200 = "#FFB3B5";
    var error300 = "#FF6669";
    var error400 = "#FB505B";
    var error500 = "#E3273F";
    var error600 = "#C51B31";
    var error700 = "#9D0C1F";
    var error800 = "#710513";
    var error900 = "#4E030D";
    var warning100 = "#FCF4E8";
    var warning200 = "#FAE5C6";
    var warning300 = "#FFBE66";
    var warning400 = "#FFAA38";
    var warning500 = "#FF9200";
    var warning600 = "#E57906";
    var warning700 = "#CA6902";
    var warning800 = "#994F00";
    var warning900 = "#663500";
    var info100 = "#D9EBFC";
    var info200 = "#A0CCF8";
    var info300 = "#61AAF2";
    var info400 = "#1D8BE2";
    var info500 = "#0378D4";
    var info600 = "#0566B3";
    var info700 = "#034F8C";
    var info800 = "#003966";
    var info900 = "#00223D";
    var pink100 = "#F8DEE6";
    var pink200 = "#F3C7D4";
    var pink300 = "#EEAFC3";
    var pink400 = "#E892AD";
    var pink500 = "#E27597";
    var pink600 = "#DD5E85";
    var pink700 = "#D84673";
    var pink800 = "#D32F61";
    var pink900 = "#B82754";
    var lightPurple100 = "#E5DDF9";
    var lightPurple200 = "#D3C5F5";
    var lightPurple300 = "#C0ADF0";
    var lightPurple400 = "#AE95EC";
    var lightPurple500 = "#9473E6";
    var lightPurple600 = "#825BE2";
    var lightPurple700 = "#6B3DDD";
    var lightPurple800 = "#5926D7";
    var lightPurple900 = "#4F22BF";
    var purple100 = "#F3E9F6";
    var purple200 = "#E6D0EC";
    var purple300 = "#DBBCE3";
    var purple400 = "#CDA3D9";
    var purple500 = "#C28FD1";
    var purple600 = "#B373C5";
    var purple700 = "#A85FBD";
    var purple800 = "#9D4BB5";
    var purple900 = "#8C42A1";
    var deepPurple100 = "#E6E1F3";
    var deepPurple200 = "#D6CDEB";
    var deepPurple300 = "#C2B4E1";
    var deepPurple400 = "#B19FD8";
    var deepPurple500 = "#9D86CE";
    var deepPurple600 = "#8C72C6";
    var deepPurple700 = "#7859BC";
    var deepPurple800 = "#6947B1";
    var deepPurple900 = "#5D3F9D";
    var indigo100 = "#E0E2F1";
    var indigo200 = "#CCD0E9";
    var indigo300 = "#B3B9DE";
    var indigo400 = "#9FA6D6";
    var indigo500 = "#848DCA";
    var indigo600 = "#707BC1";
    var indigo700 = "#5C68B9";
    var indigo800 = "#4B58AE";
    var indigo900 = "#404B95";
    var lightBlue100 = "#DEF0FC";
    var lightBlue200 = "#C4E4FA";
    var lightBlue300 = "#A3D5F7";
    var lightBlue400 = "#83C6F4";
    var lightBlue500 = "#69BAF1";
    var lightBlue600 = "#4FAEEF";
    var lightBlue700 = "#2698E4";
    var lightBlue800 = "#1479BC";
    var lightBlue900 = "#005A97";
    var blue100 = "#E2EEFC";
    var blue200 = "#C8DFFA";
    var blue300 = "#A8CDF6";
    var blue400 = "#88BBF3";
    var blue500 = "#6EACF1";
    var blue600 = "#549DEE";
    var blue700 = "#3A8FEB";
    var blue800 = "#1772D6";
    var blue900 = "#0154AF";
    var cyan100 = "#E1F4F7";
    var cyan200 = "#C5E9F0";
    var cyan300 = "#AEE1EB";
    var cyan400 = "#92D6E4";
    var cyan500 = "#7BCEDE";
    var cyan600 = "#5FC3D7";
    var cyan700 = "#189AB5";
    var cyan800 = "#00778F";
    var cyan900 = "#005D70";
    var teal100 = "#E8F3F2";
    var teal200 = "#CEE6E3";
    var teal300 = "#BBDDD9";
    var teal400 = "#A3D1CC";
    var teal500 = "#90C7C1";
    var teal600 = "#79BCB4";
    var teal700 = "#4B9D95";
    var teal800 = "#3D7E77";
    var teal900 = "#1F6159";
    var lightGreen100 = "#F0F6E8";
    var lightGreen200 = "#E0EDCE";
    var lightGreen300 = "#D3E5BA";
    var lightGreen400 = "#C3DBA0";
    var lightGreen500 = "#B6D48C";
    var lightGreen600 = "#A6CA72";
    var lightGreen700 = "#759C3B";
    var lightGreen800 = "#527422";
    var lightGreen900 = "#3C6106";
    var green100 = "#E3F0E1";
    var green200 = "#D1E7CE";
    var green300 = "#C0DDBB";
    var green400 = "#A7D0A1";
    var green500 = "#95C78E";
    var green600 = "#7FBB76";
    var green700 = "#6DB263";
    var green800 = "#5DA653";
    var green900 = "#539349";
    var lime100 = "#F8F9E4";
    var lime200 = "#F1F4CD";
    var lime300 = "#E9EEB0";
    var lime400 = "#E1E893";
    var lime500 = "#DAE37B";
    var lime600 = "#A4B500";
    var lime700 = "#8D9723";
    var lime800 = "#70790A";
    var lime900 = "#525900";
    var yellow100 = "#FFFBDE";
    var yellow200 = "#FEF7B7";
    var yellow300 = "#FEF49B";
    var yellow400 = "#FDF079";
    var yellow500 = "#FDED5D";
    var yellow600 = "#FCE941";
    var yellow700 = "#DFCC21";
    var yellow800 = "#9D8E00";
    var yellow900 = "#7C7000";
    var amber100 = "#FDF4DA";
    var amber200 = "#FCECBF";
    var amber300 = "#FBE39E";
    var amber400 = "#F9D97C";
    var amber500 = "#F8D161";
    var amber600 = "#F7C946";
    var amber700 = "#B58C17";
    var amber800 = "#99740A";
    var amber900 = "#765800";
    var orange100 = "#FDF1DF";
    var orange200 = "#FBE1BE";
    var orange300 = "#F9D5A4";
    var orange400 = "#F7C683";
    var orange500 = "#F5BA68";
    var orange600 = "#F3AB47";
    var orange700 = "#F19F2C";
    var orange800 = "#C27914";
    var orange900 = "#A4660F";
    var deepOrange100 = "#FCEAE4";
    var deepOrange200 = "#F9D1C4";
    var deepOrange300 = "#F7BDAA";
    var deepOrange400 = "#F4A58A";
    var deepOrange500 = "#F19170";
    var deepOrange600 = "#EE7850";
    var deepOrange700 = "#EB6436";
    var deepOrange800 = "#E74F1C";
    var deepOrange900 = "#C63F11";
    var brown100 = "#F0ECEA";
    var brown200 = "#E1D9D6";
    var brown300 = "#D2C6C2";
    var brown400 = "#C5B7B2";
    var brown500 = "#B9A8A1";
    var brown600 = "#A9938B";
    var brown700 = "#9C847A";
    var brown800 = "#8C7268";
    var brown900 = "#7C655C";
    var slate100 = "#E9EFFB";
    var slate200 = "#D7E3F7";
    var slate300 = "#BCC8DE";
    var slate400 = "#A2AEC4";
    var slate500 = "#8995AB";
    var slate600 = "#717D91";
    var slate700 = "#5B6578";
    var slate800 = "#454E5F";
    var slate900 = "#313845";
    return {
        // Elemental
        primary: brand500,
        secondary: brand600,
        tertiary: brand400,
        brand100: brand100,
        brand200: brand200,
        brand300: brand300,
        brand400: brand400,
        brand500: brand500,
        brand600: brand600,
        brand700: brand700,
        brand800: brand800,
        brand900: brand900,
        // Grays
        white: "#FFFFFF",
        gray050: "#FBFCFD",
        gray075: "#F5F7FA",
        gray100: "#EBEEF4",
        gray200: "#CAD0DA",
        gray300: "#BEC2CD",
        gray400: "#9A9EAA",
        gray500: "#757A87",
        gray600: "#6A6E79",
        gray700: "#3E4650",
        gray800: "#2D3238",
        gray900: "#1A1F27",
        gray925: "#15191F",
        gray950: "#11151A",
        black: "#000000",
        // Symbolic
        // old defaults
        success: isLightMode ? success500 : success300,
        error: isLightMode ? error500 : error300,
        warning: isLightMode ? warning500 : warning300,
        info: isLightMode ? info500 : info300,
        /**
         * @deprecated use info colors instead
         */
        knowledge: isLightMode ? info500 : info300,
        success100: success100,
        success200: success200,
        success300: success300,
        success400: success400,
        success500: success500,
        success600: success600,
        success700: success700,
        success800: success800,
        success900: success900,
        error100: error100,
        error200: error200,
        error300: error300,
        error400: error400,
        error500: error500,
        error600: error600,
        error700: error700,
        error800: error800,
        error900: error900,
        warning100: warning100,
        warning200: warning200,
        warning300: warning300,
        warning400: warning400,
        warning500: warning500,
        warning600: warning600,
        warning700: warning700,
        warning800: warning800,
        warning900: warning900,
        info100: info100,
        info200: info200,
        info300: info300,
        info400: info400,
        info500: info500,
        info600: info600,
        info700: info700,
        info800: info800,
        info900: info900,
        pink100: pink100,
        pink200: pink200,
        pink300: pink300,
        pink400: pink400,
        pink500: pink500,
        pink600: pink600,
        pink700: pink700,
        pink800: pink800,
        pink900: pink900,
        lightPurple100: lightPurple100,
        lightPurple200: lightPurple200,
        lightPurple300: lightPurple300,
        lightPurple400: lightPurple400,
        lightPurple500: lightPurple500,
        lightPurple600: lightPurple600,
        lightPurple700: lightPurple700,
        lightPurple800: lightPurple800,
        lightPurple900: lightPurple900,
        purple100: purple100,
        purple200: purple200,
        purple300: purple300,
        purple400: purple400,
        purple500: purple500,
        purple600: purple600,
        purple700: purple700,
        purple800: purple800,
        purple900: purple900,
        deepPurple100: deepPurple100,
        deepPurple200: deepPurple200,
        deepPurple300: deepPurple300,
        deepPurple400: deepPurple400,
        deepPurple500: deepPurple500,
        deepPurple600: deepPurple600,
        deepPurple700: deepPurple700,
        deepPurple800: deepPurple800,
        deepPurple900: deepPurple900,
        indigo100: indigo100,
        indigo200: indigo200,
        indigo300: indigo300,
        indigo400: indigo400,
        indigo500: indigo500,
        indigo600: indigo600,
        indigo700: indigo700,
        indigo800: indigo800,
        indigo900: indigo900,
        lightBlue100: lightBlue100,
        lightBlue200: lightBlue200,
        lightBlue300: lightBlue300,
        lightBlue400: lightBlue400,
        lightBlue500: lightBlue500,
        lightBlue600: lightBlue600,
        lightBlue700: lightBlue700,
        lightBlue800: lightBlue800,
        lightBlue900: lightBlue900,
        blue100: blue100,
        blue200: blue200,
        blue300: blue300,
        blue400: blue400,
        blue500: blue500,
        blue600: blue600,
        blue700: blue700,
        blue800: blue800,
        blue900: blue900,
        cyan100: cyan100,
        cyan200: cyan200,
        cyan300: cyan300,
        cyan400: cyan400,
        cyan500: cyan500,
        cyan600: cyan600,
        cyan700: cyan700,
        cyan800: cyan800,
        cyan900: cyan900,
        teal100: teal100,
        teal200: teal200,
        teal300: teal300,
        teal400: teal400,
        teal500: teal500,
        teal600: teal600,
        teal700: teal700,
        teal800: teal800,
        teal900: teal900,
        lightGreen100: lightGreen100,
        lightGreen200: lightGreen200,
        lightGreen300: lightGreen300,
        lightGreen400: lightGreen400,
        lightGreen500: lightGreen500,
        lightGreen600: lightGreen600,
        lightGreen700: lightGreen700,
        lightGreen800: lightGreen800,
        lightGreen900: lightGreen900,
        green100: green100,
        green200: green200,
        green300: green300,
        green400: green400,
        green500: green500,
        green600: green600,
        green700: green700,
        green800: green800,
        green900: green900,
        lime100: lime100,
        lime200: lime200,
        lime300: lime300,
        lime400: lime400,
        lime500: lime500,
        lime600: lime600,
        lime700: lime700,
        lime800: lime800,
        lime900: lime900,
        yellow100: yellow100,
        yellow200: yellow200,
        yellow300: yellow300,
        yellow400: yellow400,
        yellow500: yellow500,
        yellow600: yellow600,
        yellow700: yellow700,
        yellow800: yellow800,
        yellow900: yellow900,
        amber100: amber100,
        amber200: amber200,
        amber300: amber300,
        amber400: amber400,
        amber500: amber500,
        amber600: amber600,
        amber700: amber700,
        amber800: amber800,
        amber900: amber900,
        orange100: orange100,
        orange200: orange200,
        orange300: orange300,
        orange400: orange400,
        orange500: orange500,
        orange600: orange600,
        orange700: orange700,
        orange800: orange800,
        orange900: orange900,
        deepOrange100: deepOrange100,
        deepOrange200: deepOrange200,
        deepOrange300: deepOrange300,
        deepOrange400: deepOrange400,
        deepOrange500: deepOrange500,
        deepOrange600: deepOrange600,
        deepOrange700: deepOrange700,
        deepOrange800: deepOrange800,
        deepOrange900: deepOrange900,
        brown100: brown100,
        brown200: brown200,
        brown300: brown300,
        brown400: brown400,
        brown500: brown500,
        brown600: brown600,
        brown700: brown700,
        brown800: brown800,
        brown900: brown900,
        slate100: slate100,
        slate200: slate200,
        slate300: slate300,
        slate400: slate400,
        slate500: slate500,
        slate600: slate600,
        slate700: slate700,
        slate800: slate800,
        slate900: slate900,
        // Rainbow
        pink: isLightMode ? pink800 : pink300,
        lightPurple: isLightMode ? lightPurple800 : lightPurple200,
        purple: isLightMode ? purple800 : purple300,
        deepPurple: isLightMode ? deepPurple900 : deepPurple200,
        indigo: isLightMode ? indigo900 : indigo200,
        lightBlue: isLightMode ? lightBlue900 : lightBlue300,
        blue: isLightMode ? blue900 : blue300,
        darkBlue: isLightMode ? blue700 : blue500,
        cyan: isLightMode ? cyan900 : cyan300,
        teal: isLightMode ? teal900 : teal300,
        lightGreen: isLightMode ? lightGreen900 : lightGreen300,
        green: isLightMode ? green900 : green300,
        lime: isLightMode ? lime900 : lime300,
        yellow: isLightMode ? yellow900 : yellow300,
        amber: isLightMode ? amber900 : amber300,
        orange: isLightMode ? orange900 : orange300,
        deepOrange: isLightMode ? deepOrange900 : deepOrange300,
        bloodOrange: deepOrange900,
        brown: isLightMode ? brown900 : brown300,
        slate: isLightMode ? slate800 : slate400,
    };
};
export var createColorAliases = function (colors, mode) {
    var isLightMode = mode === "light";
    var primaryMuted = isLightMode ? colors.brand100 : colors.brand900;
    return {
        primaryHover: isLightMode ? colors.brand800 : colors.brand400,
        primaryMuted: primaryMuted,
        neutral: isLightMode ? colors.gray600 : colors.gray300,
        neutralHover: isLightMode ? colors.gray700 : colors.gray100,
        destructive: isLightMode ? colors.error500 : colors.error300,
        destructiveHover: isLightMode ? colors.error600 : colors.error200,
        disabledDark: isLightMode ? colors.gray200 : colors.gray700,
        disabledLight: isLightMode ? colors.gray400 : colors.gray600,
        background: isLightMode ? colors.white : colors.gray950,
        pageBackground: isLightMode ? colors.gray050 : colors.gray900,
        listBackground: isLightMode ? colors.white : colors.gray800,
        listBackgroundHover: isLightMode ? colors.gray100 : colors.gray700,
        border: isLightMode ? colors.gray300 : colors.gray600,
        textPrimary: isLightMode ? colors.gray900 : colors.gray050,
        textPrimaryInverse: isLightMode ? colors.gray050 : colors.gray900,
        textSecondary: colors.gray600,
        textDisabled: isLightMode ? colors.gray500 : colors.gray400,
        raisedSurfaces: isLightMode ? colors.white : colors.gray800,
        inputBackground: isLightMode ? colors.gray050 : colors.gray800,
        disabledInputBackground: isLightMode ? colors.gray075 : colors.gray700,
        iconsWithinComponents: isLightMode ? colors.gray600 : colors.gray400,
        animatedPlaceholder: isLightMode ? colors.gray100 : colors.gray700,
        link: colors.primary,
        helperText: isLightMode ? colors.gray600 : colors.gray400,
        labelText: isLightMode ? colors.gray600 : colors.gray400,
        // muted colors
        mutedBackgroundPrimary: primaryMuted,
        mutedBackgroundSuccess: isLightMode ? colors.success100 : colors.success900,
        mutedBackgroundWarning: isLightMode ? colors.warning100 : colors.warning900,
        mutedBackgroundError: isLightMode ? colors.error100 : colors.error900,
        mutedBackgroundInfo: isLightMode ? colors.info100 : colors.info900,
        mutedBackgroundGrayscale: isLightMode ? colors.gray200 : colors.gray900,
        mutedBadgePrimary: colors.primary,
        mutedBadgeSuccess: isLightMode ? colors.success600 : colors.success200,
        mutedBadgeWarning: isLightMode ? colors.warning600 : colors.warning400,
        mutedBadgeError: isLightMode ? colors.error600 : colors.error200,
        mutedBadgeInfo: isLightMode ? colors.info600 : colors.info200,
        mutedBadgeGrayscale: isLightMode ? colors.gray700 : colors.gray400,
        mutedTextPrimary: isLightMode ? colors.secondary : colors.primary,
        mutedTextSuccess: isLightMode ? colors.success700 : colors.success200,
        mutedTextWarning: isLightMode ? colors.warning800 : colors.warning400,
        mutedTextError: isLightMode ? colors.error700 : colors.error200,
        mutedTextInfo: isLightMode ? colors.info700 : colors.info200,
        mutedTextGrayscale: isLightMode ? colors.gray700 : colors.gray400,
    };
};
//# sourceMappingURL=colors.js.map